import * as Marionette from 'backbone.marionette';
import Backbone from 'backbone';

// @Note Updating to jQuery3 broke Marionette, instead of updating Marionette to version 3+
// that may cause more issues, we simply apply this fix.
// https://github.com/marionettejs/backbone.marionette/issues/3077#issuecomment-238217100
Marionette.Region.prototype.reset = function() {
  this.empty();

  this.el = this.options.el;

  delete this.$el;
  return this;
};

export default class BaseObject extends Marionette.Object {}
